'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.IconButton = exports.Icon = void 0

var _react = _interopRequireDefault(require('react'))

var _styledComponents = _interopRequireDefault(require('styled-components'))

var _templateObject, _templateObject2

var _excluded = ['onClick', 'angle', 'color', 'size', 'button', 'Component']

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    }
  return _extends.apply(this, arguments)
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}

var Icon = function Icon(_ref) {
  var onClick = _ref.onClick,
    angle = _ref.angle,
    color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    button = _ref.button,
    Component = _ref.Component,
    props = _objectWithoutProperties(_ref, _excluded)

  return button
    ? /*#__PURE__*/ _react['default'].createElement(
        IconButton,
        _extends(
          {
            onClick: onClick,
          },
          props
        ),
        /*#__PURE__*/ _react['default'].createElement(Component, {
          style: {
            width: ICON_SIZES[size],
            height: ICON_SIZES[size],
            transform: angle ? 'rotate('.concat(angle, 'deg)') : '',
          },
        })
      )
    : /*#__PURE__*/ _react['default'].createElement(
        IconWrapper,
        {
          color: color,
        },
        /*#__PURE__*/ _react['default'].createElement(Component, {
          style: {
            width: ICON_SIZES[size],
            height: ICON_SIZES[size],
            color: color,
            transform: angle && 'rotate('.concat(angle, 'deg)'),
          },
        })
      )
}

exports.Icon = Icon
var ICON_SIZES = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 40,
  xl: 80,
  xxl: 120,
}

var IconWrapper = _styledComponents['default'].div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  display: flex;\n  fill: ',
      ';\n  svg {\n    path {\n      fill: ',
      ';\n    }\n  }\n',
    ])),
  function (props) {
    return props.color ? props.theme.colors[props.color] : props.theme.colors.primary
  },
  function (props) {
    return props.color ? props.theme.colors[props.color] : props.theme.colors.primary
  }
)

var IconButton = _styledComponents['default'].button(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral([
      '\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  outline: 0;\n  border: 0;\n  cursor: pointer;\n  border-radius: 100%;\n  padding: ',
      ';\n  color: ',
      ';\n\n  &:hover {\n    color: ',
      ';\n  }\n  &:focus {\n    color: ',
      ';\n  }\n  &:active {\n    color: ',
      ';\n  }\n  &:disabled {\n    cursor: default;\n    color: ',
      ';\n  }\n',
    ])),
  function (props) {
    return props.theme.spacing(1)
  },
  function (props) {
    return props.color
      ? props.color in props.theme.colors
        ? props.theme.colors[props.color]
        : props.color
      : 'inherit'
  },
  function (props) {
    return props.color
      ? props.color in props.theme.colors
        ? props.theme.darken(props.theme.colors[props.color], 8)
        : props.color
      : 'inherit'
  },
  function (props) {
    return props.color
      ? props.color in props.theme.colors
        ? props.theme.darken(props.theme.colors[props.color], 8)
        : props.color
      : 'inherit'
  },
  function (props) {
    return props.color
      ? props.color in props.theme.colors
        ? props.theme.darken(props.theme.colors[props.color], 22)
        : props.color
      : 'inherit'
  },
  function (props) {
    return props.theme.colors.subtext
  }
)

exports.IconButton = IconButton
